import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import VehicleRenewalStatus from "../components/vehicleRenewalStatus";
import { useParams, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const ViewHireVehicle = () => {
  useAuthRedirect();
    const { id } = useParams();
  const navigate = useNavigate(); // Initialize navigate function
 const [branches,setbranches] = useState([]);
   const [vehtypes,setvehtypes] = useState([]);
   const userName = localStorage.getItem("username"); // Default branch from storage
   const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [formData ,setFormData] = useState({
     fld_date: "" ,branch_code: "" ,fld_vehno: "" ,fld_vcode: "" ,fld_vname: "" ,fld_vtype: "" ,fld_vbasis: "" ,fld_vcompanyname : "",
     fld_ownersname: "" ,fld_vprice: "" ,fld_contactperson: "" ,fld_address1: "" ,fld_address2: "" ,fld_city: "" ,fld_phone: "" ,
     fld_vehappperiod: "" ,fld_fcexpire: "" ,fld_icexpire: "" ,fld_food: "" ,fld_tds: "" ,fld_mobile: "" ,fld_permitexpire: "" ,
     fld_drivelinexpire: "" ,fld_dieselappr: "" ,fld_remarks: "" ,fld_panno: "" ,fld_panaddress: "" ,fld_panname: "" , fld_favouring: "" , fld_HireModel : ""
  
    });

    const canView  = hasPermission("Vehicle Renewal status", "view");

    useEffect(() => {
        axios.get("https://rfs2.infraconsoft.net.in/api/get_branches")
          .then((response) => {
            setbranches(response.data.branches);
          })
          .catch((error) => {
            console.error("Error fetching branches:" ,error);
          });
      } ,[]);
    
       useEffect(() => {
        axios.get("https://rfs2.infraconsoft.net.in/api/get_vehicle_types")
          .then((response) => {
            setvehtypes(response.data.vehtypes);
          })
          .catch((error) => {
            console.error("Error fetching data:" ,error);
          });
      } ,[]);


  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_edit_hire_vehicle_api/${id}`
        );
        setFormData({
            fld_date: response.data.fld_date,
            branch_code: response.data.branch_code,
            fld_vehno: response.data.fld_vehno,
            fld_vcode: response.data.fld_vcode,
            fld_vname: response.data.fld_vname,
            fld_vtype: response.data.fld_vtype,
            fld_vbasis: response.data.fld_vbasis,
            fld_vcompanyname: response.data.fld_vcompanyname  ,
            fld_ownersname: response.data.fld_ownersname,
            fld_vprice: response.data.fld_vprice,
            fld_contactperson: response.data.fld_contactperson,
            fld_address1: response.data.fld_address1,
            fld_address2: response.data.fld_address2,
            fld_city: response.data.fld_city,
            fld_phone: response.data.fld_phone,
            fld_vehappperiod: response.data.fld_vehappperiod,
            fld_fcexpire: response.data.fld_fcexpire,
            fld_icexpire: response.data.fld_icexpire,
            fld_food: response.data.fld_food,
            fld_tds: response.data.fld_tds,
            fld_mobile: response.data.fld_mobile,
            fld_permitexpire: response.data.fld_permitexpire,
            fld_drivelinexpire: response.data.fld_drivelinexpire,
            fld_dieselappr: response.data.fld_dieselappr,
            fld_remarks: response.data.fld_remarks,
            fld_panno: response.data.fld_panno,
            fld_panaddress: response.data.fld_panaddress,
            fld_panname: response.data.fld_panname,
            fld_favouring: response.data.fld_favouring,
            fld_HireModel : response.data.fld_HireModel,
            fld_closinglogid : response.data.fld_closinglogid,
            fld_closingremarks : response.data.fld_closingremarks,
            fld_closingdate : response.data.fld_closingdate
           
        });
      } catch (error) {
        console.error("Error fetching  details:", error);
      }
    };

    fetchLocation();
  }, [id]);


  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
          <div className="back-div">
  <h2 className="add-txt">Closed Hire Vehicle Details - View</h2>
  <p className="back-button" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
    <i className="fa-solid fa-backward"></i> Back
  </p>
</div>
          
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
        <form className="vehicle-form">

                      <h3> Closed Hire Vehicle Details</h3><br/><br/>
            <div className="form-row">
              <div className="form-group">
                <label>Closed By :</label>
                <input
                  type="text"
                  name="fld_closinglogid"
                  value={formData.fld_closinglogid}
                  
                  readOnly
                />
                
              </div>
              <div className="form-group">
                <label>Reason For Closing:</label>
                <input
                  type="text"
                  name="fld_closingremarks"
                  value={formData.fld_closingremarks}
                  
                  readOnly
                />
                  </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Closing Date :</label>
                <input
                  type="text"
                  name="fld_closingdate"
                   value={new Date(formData.fld_closingdate).toLocaleDateString("en-GB")}
                  readOnly
                />
                
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"/>
                  </div>
            </div>


 <h3>  Vehicle Info           </h3><br/><br/>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input
                  type="text"
                  name="fld_vcode"
                  value={formData.fld_vcode}
                  
                  readOnly 
                />
              </div>
              <div className="form-group">
                <label>Vehicle Type:</label>
                <input
                  type="text"
                  name="fld_vcode"
                  value={formData.fld_vtype}
                  
                  readOnly 
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Register Number:</label>
                <input
                  type="text"
                  name="fld_vehno"
                  value={formData.fld_vehno}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Model:</label>
                <input
                  type="text"
                  name="fld_HireModel"
                  value={formData.fld_HireModel}
                  
                  readOnly
                />
              </div> 
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name:</label>
                <input
                  type="text"
                  name="fld_vname"
                  value={formData.fld_vname}
                  
                  readOnly
                />
              </div>    
              <div className="form-group"></div>           
            </div>
            <h3> Contact Info</h3><br/><br/>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Company name:</label>
                <input
                  type="text"
                  name="fld_vcompanyname"
                  value={formData.fld_vcompanyname}
                  
                  readOnly
                />
                
              </div>
              <div className="form-group">
                <label>Vehicle Basis:</label>
                <input
                  type="text"
                  name="fld_vbasis"
                  value={formData.fld_vbasis}
                  
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Address Line 1:</label>
                <input
                  type="text"
                  name="fld_address1"
                  value={formData.fld_address1}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Address Line 2:</label>
                <input
                  type="text"
                  name="fld_address2"
                  value={formData.fld_address2}
                  
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Rent:</label>
                <input
                  type="text"
                  name="fld_vprice"
                  value={formData.fld_vprice}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Owner's Name:</label>
                <input
                  type="text"
                  name="fld_ownersname"
                  value={formData.fld_ownersname}
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City:</label>
                <input
                  type="text"
                  name="fld_city"
                  value={formData.fld_city}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>TelePhone:</label>
                <input
                  type="text"
                  name="fld_phone"
                  value={formData.fld_phone}
                  
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Contact person:</label>
                <input
                  type="text"
                  name="fld_contactperson"
                  value={formData.fld_contactperson}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Vehicle Approval Date:</label>
                <input
                  type="text"
                  name="fld_vehappperiod"
                  value={formData.fld_vehappperiod}
                  
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Mobile no:</label>
                <input
                  type="text"
                  name="fld_mobile"
                  value={formData.fld_mobile}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={formData.fld_fcexpire} />(FC)
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <VehicleRenewalStatus renewalDate={formData.fld_permitexpire} />(Permit)
              </div>
              <div className="form-group">
              <VehicleRenewalStatus renewalDate={formData.fld_icexpire} />(IC)
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Food For Driver:</label>
                <input
                  type="text"
                  name="fld_food"
                  value={formData.fld_food}
                  
                  readOnly
                />
               
              </div>
              <div className="form-group">
                <label>TDS:</label>
                <input
                  type="text"
                  name="fld_tds"
                  value={formData.fld_tds}
                  
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Diesel:</label>
                <input
                  type="text"
                  name="fld_dieselappr"
                  value={formData.fld_dieselappr}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Cheque Favouring Name:</label>
                <input
                  type="text"
                  name="fld_favouring"
                  value={formData.fld_favouring}
                  
                  readOnly
                />
                  </div>
            </div>
           
            <div className="form-row">
              <div className="form-group">
                <label>PAN Holder Name:</label>
                <input
                  type="text"
                  name="fld_panname"
                  value={formData.fld_panname}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>PAN Card no:</label>
                <input
                  type="text"
                  name="fld_panno"
                  value={formData.fld_panno}
                  
                  readOnly
                />
                  </div>
            </div>
           
            <div className="form-row">
              <div className="form-group">
                <label>Mailing Address:</label>
                <input
                  type="text"
                  name="fld_panaddress"
                  value={formData.fld_panaddress}
                  
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Remarks:</label>
                <input
                  type="text"
                  name="fld_remarks"
                  value={formData.fld_remarks}
                  
                  readOnly
                />
                  </div>
            </div>

           
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default ViewHireVehicle;
 